import script from "./TheRequiredAddressComfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRequiredAddressComfirm.vue?vue&type=script&setup=true&lang=js"

import "./TheRequiredAddressComfirm.vue?vue&type=style&index=0&id=4a4ba484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4ba484"]])

export default __exports__